import { render, staticRenderFns } from "./DossierAutoSaleRowSettingAddSharedFunc.vue?vue&type=template&id=436830f2&scoped=true&"
import script from "./DossierAutoSaleRowSettingAddSharedFunc.vue?vue&type=script&lang=ts&"
export * from "./DossierAutoSaleRowSettingAddSharedFunc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436830f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('436830f2')) {
      api.createRecord('436830f2', component.options)
    } else {
      api.reload('436830f2', component.options)
    }
    module.hot.accept("./DossierAutoSaleRowSettingAddSharedFunc.vue?vue&type=template&id=436830f2&scoped=true&", function () {
      api.rerender('436830f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierAutoSaleRowSettingAddSharedFunc.vue"
export default component.exports